import { DkimStatus } from "@redotech/redo-marketing-core-common/email/domain-verification";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

const linkedTeamSchema = z.object({ _id: zExt.objectId(), name: z.string() });

export const getEmailDomainLinksForTeam = {
  name: "getEmailDomainLinksForTeam" as const,
  input: z.object({ teamId: zExt.objectId() }),
  output: z.object({
    domains: z.array(
      z.object({
        domain: z.string(),
        dkimStatus: createEnum(DkimStatus),
        teams: z.array(linkedTeamSchema),
      }),
    ),
  }),
};
